/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { Link, useLocation } from 'react-router-dom';
import { useLearningOutcomeReportsAccess } from '@components/Component/LearningOutcomeReports/IsLearningOutcomeReportsFlagEnabled';
import ShowIf from '@components/Atoms/ShowIf';

import { useIsDistrictAdmin, useIsStudent, useHasRole } from '@reducers/user/hooks';
import {
  LeftSiderBarContentGroup,
  LeftSideBarList,
  ItemsSiderBar,
  TitleSideBar,
  SideBarContent,
  LeftSiderBarWrap,
  ActionShowHide,
  SideBarContentTitle,
} from './LeftSiderBar.style';

import { useAvailableReportsQuery, useReportsFeatureAccessQuery } from '../ReportGenerator/ReportQueries';

export default class LeftSideBarAdmin extends Component {
  static propTypes = {
    match: PropTypes.any,
    pathName: PropTypes.string,
    toggleLeftSidebar: PropTypes.func,
    isSideBarClose: PropTypes.bool,
    roleName: PropTypes.string,
    user: PropTypes.shape(),
  };

  toggleLeftSidebar = () => {
    const { toggleLeftSidebar } = this.props;
    toggleLeftSidebar();
  };

  render() {
    const { isSideBarClose } = this.props;

    return (
      <LeftSiderBarWrap isClose={isSideBarClose} role="navigation" aria-label="Admin navigation">
        <AdminSideBarContent />
        <ActionShowHide className="toggle-icon" onClick={this.toggleLeftSidebar}>
          <MediaQuery maxWidth={960}>
            {(matches) =>
              matches ? (
                <span
                  className={isSideBarClose ? 'chalktalk-icon-bold-up' : 'chalktalk-menu'}
                />
              ) : (
                <span
                  className={isSideBarClose ? 'chalktalk-menu' : 'chalktalk-icon-bold-up'}
                />
              )
            }
          </MediaQuery>
        </ActionShowHide>
      </LeftSiderBarWrap>
    );
  }
}

const AdminSideBarContent = () => {
  const location = useLocation();
  const defaulUrl = `/admin/reports/generator`;
  const isStudent = useIsStudent();
  const isDistrictAdmin = useIsDistrictAdmin();
  const { data: availableReportsData } = useAvailableReportsQuery();
  const dataDashboardAvailable = availableReportsData?.data_dashboard_available || false;
  const isLearningOutcomeReportsEnabled = useLearningOutcomeReportsAccess({
    suspense: true,
  });
  const isPMReportsEnabled = useReportsFeatureAccessQuery('pm_reports');
  const isAccountabilityEnabled = useReportsFeatureAccessQuery('accountability_reports');
  const hasRole = useHasRole();

  if (!hasRole) {
    return null;
  }

  return (
    // sidebar for admin reports
    <LeftSiderBarContentGroup>
      <TitleSideBar>Reports</TitleSideBar>
      <LeftSideBarList>
        <>
          <Link to={defaulUrl}>
            <ItemsSiderBar
              isActive={location.pathname.startsWith('/admin/reports/generator')}
            >
              <SideBarContent>
                <SideBarContentTitle>
                  <img src="/images/report-generator-icon.svg" alt='Magic wand' />
                  <span>Report Generator</span>
                </SideBarContentTitle>
              </SideBarContent>
            </ItemsSiderBar>
          </Link>
          {!isStudent && dataDashboardAvailable && (
            <Link to={`/admin/reports/data-dashboard`}>
              <ItemsSiderBar
                isActive={'/admin/reports/data-dashboard' == location.pathname}
              >
                <SideBarContent>
                  <SideBarContentTitle>
                    <img src="/images/profit-report.svg" alt='Page showing graph going up to the right' />
                    <span>Data Dashboard</span>
                  </SideBarContentTitle>
                </SideBarContent>
              </ItemsSiderBar>
            </Link>
          )}
          <ShowIf If={!isStudent && isPMReportsEnabled}>
            <Link to={`/admin/reports/pm-outcomes`}>
              <ItemsSiderBar
                isActive={'/admin/reports/pm-outcomes' == location.pathname}
              >
                <SideBarContent>
                  <SideBarContentTitle>
                    <img src="/images/profit-report.svg" alt='Page showing graph going up to the right' />
                    <span>Progress Monitoring</span>
                  </SideBarContentTitle>
                </SideBarContent>
              </ItemsSiderBar>
            </Link>
          </ShowIf>
          <ShowIf If={!isStudent && isAccountabilityEnabled}>
            <Link to={`/admin/reports/accountability`}>
              <ItemsSiderBar
                isActive={'/admin/reports/accountability' == location.pathname}
              >
                <SideBarContent>
                  <SideBarContentTitle>
                    <img src="/images/profit-report.svg" alt='Page showing graph going up to the right' />
                    <span>Teacher Accountability</span>
                    <span className="beta">BETA</span>
                  </SideBarContentTitle>
                </SideBarContent>
              </ItemsSiderBar>
            </Link>
          </ShowIf>
          <ShowIf If={!isStudent && isDistrictAdmin && isLearningOutcomeReportsEnabled}>
            <Link to={`/admin/reports/learning-outcomes`}>
              <ItemsSiderBar
                isActive={'/admin/reports/learning-outcomes' == location.pathname}
              >
                <SideBarContent>
                  <SideBarContentTitle>
                    <img src="/images/profit-report.svg" alt='Page showing graph going up to the right' />
                    <span>(District) Learning Outcomes</span>
                  </SideBarContentTitle>
                </SideBarContent>
              </ItemsSiderBar>
            </Link>
          </ShowIf>
        </>
      </LeftSideBarList>
    </LeftSiderBarContentGroup>
  );
};
